/* src/app/system-utils/notifications-card/notifications-card.component.scss */
.bell-trigger {
  display: inline-flex;
  cursor: pointer;
}
.bell-icon {
  font-size: 20px;
  color: var(--tem-deep);
}
.notif-panel {
  width: 360px;
  max-width: 90vw;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
  overflow: hidden;
  font-family: var(--tem-font-family);
}
.notif-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
}
.notif-title-h {
  font-weight: 600;
  font-size: 15px;
  color: var(--tem-ink);
}
.mark-all {
  font-size: 12px;
  color: var(--tem-deep);
}
.notif-list {
  max-height: 380px;
  overflow-y: auto;
}
.notif-item {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid var(--tem-border);
  transition: background 0.15s ease;
  position: relative;
}
.notif-item:hover {
  background: var(--tem-accent-soft);
}
.notif-item.unread {
  background: color-mix(in srgb, var(--tem-deep) 8%, transparent);
}
.notif-item.unread:hover {
  background: color-mix(in srgb, var(--tem-deep) 14%, transparent);
}
.notif-icon {
  font-size: 18px;
  margin-top: 2px;
}
.notif-icon.info {
  color: var(--tem-deep);
}
.notif-icon.sucesso {
  color: var(--tem-success);
}
.notif-icon.atencao {
  color: var(--tem-warn);
}
.notif-icon.falha {
  color: var(--tem-danger);
}
.notif-body {
  flex: 1;
  min-width: 0;
}
.notif-line1 {
  font-weight: 500;
  font-size: 14px;
  color: var(--tem-ink);
}
.notif-msg {
  font-size: 13px;
  color: var(--tem-muted);
  margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notif-time {
  font-size: 11px;
  color: color-mix(in srgb, var(--tem-muted) 75%, transparent);
  margin-top: 4px;
}
.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--tem-accent);
  align-self: center;
  flex: 0 0 auto;
}
.notif-empty {
  padding: 28px 0;
}
.notif-footer {
  text-align: center;
  padding: 10px;
  border-top: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
}
.notif-footer a {
  color: var(--tem-deep);
}
.islink {
  text-decoration: underline;
  cursor: pointer;
}
.islink:hover {
  color: var(--tem-deep);
}
/*# sourceMappingURL=notifications-card.component.css.map */
